<script setup lang="ts">
import { HeadingFormElement } from "~/api";

const props = defineProps<{ modelValue: HeadingFormElement }>();
</script>

<template>
  <div class="HeadingComponent">
    <div
      v-if="modelValue.label"
      :class="['heading-level-' + modelValue.properties.headingLevel]"
    >
      <slot name="label" :element="modelValue" />
    </div>
  </div>
</template>
<style lang="less" scoped>
.HeadingComponent {
  background-color: var(--el-text-color-primary);
  margin: 0 -6px; // make it slightly wider
  color: #ffffff;
  font-size: 20px; // default size

  div {
    margin-left: 15px;
  }

  .heading-level-0 {
    font-size: 20px;
  }

  .heading-level-1 {
    font-size: 1.1em;
  }

  .heading-level-2 {
    font-size: 1.2em;
  }

  .heading-level-3 {
    font-size: 0.9em;
  }
}
</style>
